import React, { useEffect } from "react"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
import api from "services/api.service"
import { userService } from "services/user.service"
import isNullOrEmpty from "utils/isNullOrEmpty"

const ActionItemsOptions = ({
  scenarioId,
  scenario,
  pageItem,
  alternative,
  alternativeMetadata,
  actionItems,
  setActiveDrawer,
  toggleBaselineComparisonModal,
  toggleProjectArtifactsModal,
  toggleAltModal,
  toggleReportModal,
  deleteAlternative,
  toggleLock,
  toggleStageUncertaintyModal,
  toggleLogModal,
  toggleProjectSummaryModal,
  showScoringForScenario,
  loadChart2,
  setShowRoadMap,
  showAiSummary,
  setShowAiSummary,
  showRoadMap,
  setSelectedActionItem,
  setReportActionItem,
  toggleActionReportModal,
}) => {
  const currentUser = userService.getLoggedInUser()
  const [showActionsDropdown, setShowActionsDropdown] = React.useState(false)
  const [alternativeActionItems, setAlternativeActionItems] = React.useState([])

  useEffect(() => {
    loadActionItems()
  }, [])

  const loadActionItems = async () => {
    let alternativeActionItems = await api.getUserActionRights(
      scenarioId,
      "AlternativeActions"
    )
    setAlternativeActionItems(alternativeActionItems)
    console.log("AlternativeActions:", alternativeActionItems)
  }

  const hasActionItem = actionItemName => {
    return alternativeActionItems.some(
      item => item.actionItem === actionItemName
    )
  }

  const renderActionMenuItem = (item, idx) => {
    let onClickHandler = null
    if (item.actionType == "Report") {
      onClickHandler = () => {
        setReportActionItem(item)
        toggleActionReportModal()
      }
    } else {
      onClickHandler = () => {
        setActiveDrawer("manageTasks")
        setSelectedActionItem(item)
      }
    }

    return (
      <DropdownItem
        key={idx}
        className="always-enabled"
        onClick={onClickHandler}
      >
        <div className="d-flex-row ai-center gap-1">
          <i className={item.iconClass}></i> <span>{item.actionName}</span>
          {!isNullOrEmpty(alternativeMetadata) &&
            alternativeMetadata[`taskType_${item.actionTypeItemID}`] !=
              undefined && (
              <span
                className="badge bg-danger rounded-pill"
                style={{ marginLeft: "10px" }}
              >
                {alternativeMetadata[`taskType_${item.actionTypeItemID}`]}
              </span>
            )}
        </div>
      </DropdownItem>
    )
  }

  return (
    <Dropdown
      direction="start"
      style={{ display: "inline-block" }}
      // className=""
      isOpen={showActionsDropdown}
      toggle={() => setShowActionsDropdown(!showActionsDropdown)}
    >
      <DropdownToggle
        tag="button"
        className="btn btn-outline-primary save-user always-enabled"
      >
        Actions <i className="mdi mdi-chevron-down" />
      </DropdownToggle>

      <DropdownMenu>
        {hasActionItem("Comments") && (
          <DropdownItem
            className="always-enabled"
            onClick={() => setActiveDrawer("Note")}
          >
            <div className="d-flex-row ai-center gap-1">
              <i className="mdi mdi-chat-outline"></i>
              <span>Comments</span>
              <span
                className="badge bg-danger rounded-pill"
                style={{ marginLeft: "10px" }}
              >
                {alternativeMetadata?.comments}
              </span>
            </div>
          </DropdownItem>
        )}
        {!alternative.ideaOnly && hasActionItem("Comparison") && (
          <DropdownItem
            className="always-enabled"
            onClick={() => toggleBaselineComparisonModal()}
          >
            <i className="mdi mdi-compare-horizontal"></i>
            Compare to
          </DropdownItem>
        )}
        {!alternative.ideaOnly && (
          <DropdownItem
            className="always-enabled"
            onClick={() => {
              let bcIdBase64 = btoa(alternative.businessCaseID)
              let txt =
                window.location.href.replace(window.location.pathname, "") +
                "/login.aspx?bc=" +
                bcIdBase64

              navigator.clipboard.writeText(txt)
              toast.success("Link copied to clipboard")
            }}
          >
            <i className="fas fa-link"></i> Copy Link
          </DropdownItem>
        )}
        {/* {!alternative.ideaOnly &&
          currentUser.useAI &&
          (alternative.pmUserID == currentUser.userID ||
            alternative.brmUserID == currentUser.userID) &&
          hasActionItem("ProjectArtifacts") && ( */}
            <DropdownItem
              className="always-enabled"
              onClick={toggleProjectArtifactsModal}
            >
              <i className="fas fa-file-word"></i> Create Project Artifacts
            </DropdownItem>
          {/* )} */}

        {(alternative.ideaOnly || hasActionItem("Delete")) && (
          <DropdownItem onClick={deleteAlternative}>
            <i className="mdi mdi-trash-can-outline"></i> Delete
          </DropdownItem>
        )}

        {hasActionItem("Documents and Links") && (
          <DropdownItem
            className="always-enabled"
            onClick={() => setActiveDrawer("Document")}
          >
            <div className="d-flex-row ai-center gap-1">
              <i className="mdi mdi-file-document-multiple-outline"></i>{" "}
              <span>Documents and Links</span>
              <span
                className="badge bg-danger rounded-pill"
                style={{ marginLeft: "10px" }}
              >
                {alternativeMetadata?.documents}
              </span>
            </div>
          </DropdownItem>
        )}

        {!alternative.ideaOnly && (
          <>
            <DropdownItem className="always-enabled" onClick={toggleAltModal}>
              <i className="mdi mdi-arrow-top-right-bold-outline"></i> Go To
            </DropdownItem>
            {hasActionItem("Lock") && (
              <DropdownItem className="always-enabled" onClick={toggleLock}>
                <i className="mdi mdi-lock"></i>{" "}
                {alternative && alternative.locked
                  ? "Unlock Business Case"
                  : "Lock Business Case"}
              </DropdownItem>
            )}
            <DropdownItem
              className="always-enabled"
              onClick={toggleReportModal}
            >
              <i className="fas fa-file-pdf"></i> Run Business Case Report
            </DropdownItem>
            {hasActionItem("Score") && pageItem && pageItem.userAltScoring && (
              <DropdownItem
                className="always-enabled"
                onClick={() => {
                  showScoringForScenario(scenario.scenarioID)
                }}
              >
                <i className="mdi mdi-bullseye"></i> Score{" "}
                {scenario.alternativeName} {scenario.scoreName}
              </DropdownItem>
            )}

            {hasActionItem("Score") &&
              scenario.secondaryScenarioID_Risk > 0 &&
              pageItem &&
              pageItem.userSecondaryAltScoring_Risk && (
                <DropdownItem
                  className="always-enabled"
                  onClick={() => {
                    showScoringForScenario(scenario.secondaryScenarioID_Risk)
                  }}
                >
                  <i className="mdi mdi-bullseye"></i> Score{" "}
                  {scenario.alternativeName} {scenario.secondaryScoreName_Risk}
                </DropdownItem>
              )}

            {hasActionItem("Score") &&
              scenario.secondaryScenarioID_Benefit > 0 &&
              pageItem &&
              pageItem.userSecondaryAltScoring_Benefit && (
                <DropdownItem
                  className="always-enabled"
                  onClick={() => {
                    showScoringForScenario(scenario.secondaryScenarioID_Benefit)
                  }}
                >
                  <i className="mdi mdi-bullseye"></i> Score{" "}
                  {scenario.alternativeName}{" "}
                  {scenario.secondaryScoreName_Benefit}
                </DropdownItem>
              )}

            {hasActionItem("Score") &&
              scenario.secondaryScenarioID_Outcome > 0 &&
              pageItem &&
              pageItem.userSecondaryAltScoring_Outcome && (
                <DropdownItem
                  className="always-enabled"
                  onClick={() => {
                    showScoringForScenario(scenario.secondaryScenarioID_Outcome)
                  }}
                >
                  <i className="mdi mdi-bullseye"></i> Score{" "}
                  {scenario.alternativeName}{" "}
                  {scenario.secondaryScoreName_Outcome}
                </DropdownItem>
              )}

            {currentUser.useAI &&
              alternative != null &&
              alternative.chatGPTSummary &&
              alternative.chatGPTSummary != "" && (
                <DropdownItem
                  className="always-enabled"
                  onClick={e => {
                    setShowAiSummary(!showAiSummary)
                  }}
                >
                  <i className="mdi mdi-brain"></i>{" "}
                  {showAiSummary ? "Hide AI Summary" : "Show AI Summary"}
                </DropdownItem>
              )}

            <DropdownItem
              className="always-enabled"
              onClick={e => {
                setShowRoadMap(!showRoadMap)
                loadChart2()
              }}
            >
              <i className="fas fa-road"></i>{" "}
              {showRoadMap ? "Hide Roadmap" : "Show Roadmap"}
            </DropdownItem>

            {hasActionItem("ConeOfUncertainty") && (
              <DropdownItem
                className="always-enabled"
                onClick={() => toggleStageUncertaintyModal()}
              >
                <i className="fas fa-funnel-dollar"></i> View Cone of
                Uncertainty
              </DropdownItem>
            )}

            {hasActionItem("ViewLog") && (
              <DropdownItem
                className="always-enabled"
                onClick={() => toggleLogModal()}
              >
                <i className="mdi mdi-history"></i> View Log
              </DropdownItem>
            )}

            {(scenario == null || scenario.projectPlanTabID != 0) &&
              hasActionItem("ViewProjectStatus") && (
                <DropdownItem
                  className="always-enabled"
                  onClick={toggleProjectSummaryModal}
                >
                  <i className="mdi mdi-table-headers-eye"></i> View Project
                  Status
                </DropdownItem>
              )}

            <div
              style={{
                paddingTop: "5px",
                paddingLeft: "5px",
                fontWeight: "600",
              }}
            >
              Tracking Items
            </div>

            {actionItems.map((a, idx) => renderActionMenuItem(a, idx))}
          </>
        )}
        {/* <DropdownItem>Information</DropdownItem> */}
      </DropdownMenu>
    </Dropdown>
  )
}

export default ActionItemsOptions
